import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const BlogCollectionFragment = gql`
  fragment BlogCollectionFragment on BlogCollection {
    id
    collectionId
    title
    description
    image
    postIds
    createdAt
    updatedAt
  }
`;

export const list = gql`
  query BlogCollectionList($siteId: String!, $input: ListInput) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            blog {
              id
              collections {
                id
                list(input: $input) {
                  id
                  last
                  items {
                    ...BlogCollectionFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BlogCollectionFragment}
`;

export const get = gql`
  query BlogCollectionGet($siteId: String!, $collectionId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            blog {
              id
              collections {
                id
                get(collectionId: $collectionId) {
                  ...BlogCollectionFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BlogCollectionFragment}
`;

export const create = gql`
  mutation BlogCollectionNew($siteId: String!, $input: BlogCollectionInputCreate!) {
    viewer {
      account {
        sites {
          get(siteId: $siteId) {
            blog {
              collections {
                create(input: $input) {
                  ...BlogCollectionFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${BlogCollectionFragment}
`;

export const edit = gql`
  mutation BlogCollectionUpdate($siteId: String!, $collectionId: String!, $input: BlogCollectionInputUpdate!) {
    viewer {
      account {
        sites {
          get(siteId: $siteId) {
            blog {
              collections {
                get(collectionId: $collectionId) {
                  update(input: $input) {
                    ...BlogCollectionFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${BlogCollectionFragment}
`;

export const remove = gql`
  mutation BlogCollectionRemove($siteId: String!, $collectionId: String!) {
    viewer {
      account {
        sites {
          get(siteId: $siteId) {
            blog {
              collections {
                get(collectionId: $collectionId) {
                  remove
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const update = () => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`blog/collections/queries`)) {
      cache.data.delete(key);
    }
  });
};
